var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.416 13.1639C13.416 12.3717 14.0582 11.7295 14.8504 11.7295H26.3254C27.1176 11.7295 27.7598 12.3717 27.7598 13.1639V27.5076C27.7598 28.2998 27.1176 28.942 26.3254 28.942H14.8504C14.0582 28.942 13.416 28.2998 13.416 27.5076V13.1639ZM23.686 14.7628C23.93 15.0069 23.93 15.4026 23.686 15.6467L19.9672 19.3654C19.7231 19.6095 19.3274 19.6095 19.0833 19.3654L17.4896 17.7717C17.2455 17.5276 17.2455 17.1319 17.4896 16.8878C17.7337 16.6437 18.1294 16.6437 18.3735 16.8878L19.5253 18.0396L22.8021 14.7628C23.0462 14.5187 23.4419 14.5187 23.686 14.7628ZM15.5676 23.2045C15.5676 22.8084 15.8887 22.4873 16.2848 22.4873H24.891C25.2871 22.4873 25.6082 22.8084 25.6082 23.2045C25.6082 23.6006 25.2871 23.9217 24.891 23.9217H16.2848C15.8887 23.9217 15.5676 23.6006 15.5676 23.2045ZM16.2848 25.3561C15.8887 25.3561 15.5676 25.6772 15.5676 26.0732C15.5676 26.4693 15.8887 26.7904 16.2848 26.7904H22.7395C23.1355 26.7904 23.4566 26.4693 23.4566 26.0732C23.4566 25.6772 23.1355 25.3561 22.7395 25.3561H16.2848Z",
    fill: "#4251DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRate);
export default __webpack_public_path__ + "static/media/rate.3d4c9ff0282554058daa6484c8772062.svg";
export { ForwardRef as ReactComponent };